import { Component, OnInit, Input } from '@angular/core';

// config
import { appConfig } from '../../../config/app-config';

// Core
import { ErrorMessage } from '../../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../../core/interfaces/bool-result';
import { UiMessageSnackService } from '../../../core/components/message-snack/service/message-snack.service';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

@Component({
   selector: 'app-breadcrumb-cont',
   templateUrl: './breadcrumb-cont.component.html',
   styleUrls: ['./breadcrumb-cont.component.scss']
})
export class BreadcrumbContComponent implements OnInit {

   // input
   @Input() public disableLink = false;

   // select
   @select((s: IAppState) => s.breadcrumbState.crumbs0) breadcrumbs$;

   constructor(
      private _store: NgRedux<IAppState>
   ) { }

   ngOnInit() {
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/components/breadcrumb/breadcrumb-cont.component.ts